export const GET_BONUSES_REQUEST = 'GET_BONUSES_REQUEST'
export const SET_BONUSES_STATE = 'SET_BONUSES_STATE'

export const SET_BONUSES = 'SET_BONUSES'
export const SAVE_BONUSES_REQUEST = 'SAVE_BONUSES_REQUEST'
export const REMOVE_BONUS_REQUEST = 'REMOVE_BONUS_REQUEST'
